import type { Endpoints } from '~/types/endpoints'

const fetchPSActualities = () =>
  myFetch<Endpoints['GET__HIGHLIGHTED_COMMUNITIES_ARTICLES']>(
    API.GET__HIGHLIGHTED_COMMUNITIES_ARTICLES,
  )

const fetchActualities = () => {
  const nuxtApp = useNuxtApp()
  return useAsyncData('PSActualities', fetchPSActualities, {
    getCachedData: (key) =>
      nuxtApp.payload.data[key] ?? nuxtApp.static.data[key],
    transform: (actualities) =>
      actualities.flatMap((actuality) => {
        if (!actuality) return []
        return {
          ...actuality,
          route: `/actualites-playstation/${actuality.slug}`,
          type: 'actuality',
          user: actuality.contributor,
        }
      }),
  })
}

export const useFetchPSActualities = async () => {
  const { data: fetchedPSActualities } = await fetchActualities()
  return fetchedPSActualities.value ?? []
}
